import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    selection: _ctx.selectedFiles,
    "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedFiles = $event)),
    value: _ctx.files,
    loading: _ctx.loading,
    class: "p-datatable-sm kn-table",
    dataKey: "DOCUMENT_ID",
    responsiveLayout: "stack",
    filters: _ctx.filters,
    "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
    filterDisplay: "menu",
    globalFilterFields: _ctx.addActionDialogDescriptor.documentFilterFields,
    onRowSelect: _ctx.fileSelected,
    onRowUnselect: _ctx.fileSelected,
    onRowSelectAll: _ctx.fileSelected,
    onRowUnselectAll: _ctx.fileSelected
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            class: "kn-material-input",
            type: "text",
            modelValue: _ctx.filters['global'].value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
            placeholder: _ctx.$t('common.search'),
            badge: "0",
            "data-test": "search-input"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
    ]),
    loading: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        selectionMode: "multiple",
        headerStyle: "width: 3rem"
      }),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.addActionDialogDescriptor.columnsDocument, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          field: col.field,
          header: _ctx.$t(col.header),
          key: col.field,
          sortable: true,
          class: "kn-truncated"
        }, {
          body: _withCtx((slotProps) => [
            _createVNode("span", null, _toDisplayString(slotProps.data[slotProps.column.props.field]), 1)
          ]),
          _: 2
        }, 1032, ["field", "header"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["selection", "value", "loading", "filters", "globalFilterFields", "onRowSelect", "onRowUnselect", "onRowSelectAll", "onRowUnselectAll"]))
}